"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const office = {
  name: "新宿四谷心理カウンセリングルーム",
  address: "〒160-0006 東京都新宿区舟町4-1 メゾンド四谷303号室",
  tel: "080-9553-8244",
  hours: "10:00〜21:00",
  holiday: "不定休"
};
export default function OfficeLocations() {
  return <section data-section-id="252342" id="access" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-10">
          <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">アクセス</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">交通案内</h2>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">

          <div className="order-1">
            <h3 className="text-xl font-bold text-foreground font-default mb-6">{office.name}</h3>
            <dl className="border-y border-border divide-y divide-border">
              <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
                <dt className="text-sm text-muted-foreground font-default">住所</dt>
                <dd className="text-foreground font-default leading-relaxed">{office.address}</dd>
              </div>
              <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
                <dt className="text-sm text-muted-foreground font-default">電話番号</dt>
                <dd className="text-foreground font-default font-bold"><Link to={`tel:${office.tel}`} className="hover:text-primary-heading transition-colors">{office.tel}</Link></dd>
              </div>
              <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
                <dt className="text-sm text-muted-foreground font-default">開室時間</dt>
                <dd className="text-foreground font-default">{office.hours}</dd>
              </div>
              <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
                <dt className="text-sm text-muted-foreground font-default">定休日</dt>
                <dd className="text-foreground font-default">{office.holiday}</dd>
              </div>
              <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
                <dt className="text-sm text-muted-foreground font-default">交通アクセス</dt>
                <dd className="text-foreground font-default leading-relaxed">東京メトロ丸ノ内線「四谷三丁目駅」より徒歩約4分<br />都営新宿線「曙橋駅」より徒歩約7分</dd>
              </div>
            </dl>
            <p className="text-sm text-muted-foreground font-default mt-6">※営業・勧誘のお電話はお控えください</p>
          </div>

          <div className="order-2 rounded-lg overflow-hidden shadow-lg h-[320px] lg:h-auto lg:min-h-[420px]">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1237.4153016886016!2d139.7205894390397!3d35.689192693219425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ced86155bcf%3A0x7bc4ab78a1984722!2z44CSMTYwLTAwMDYg5p2x5Lqs6YO95paw5a6_5Yy66Iif55S677yU4oiS77yR!5e0!3m2!1sja!2sjp!4v1778555013857!5m2!1sja!2sjp" title="新宿四谷心理カウンセリングルームの地図" className="w-full h-full" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>

        </div>
      </div>
    </section>;
}